export type EventData = Object;

export enum PublicEvents {
  USER_LOGGED_IN = 'userLoggedIn',
  USER_LOGGED_OUT = 'userLoggedOut',
}

export type PublicEvent<T extends EventData = EventData> = {
  name: string;
  data: T;
};
